<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>内容推荐</el-breadcrumb-item>
        <el-breadcrumb-item>推荐位置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">推荐位置</h2>
        </div>
        <div class="right">
          <el-button class="button" type="primary" @click="handlePositionCreate">添加位置</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap" ref="searchForm" :inline="true" :model="query">
        <el-form-item label="位置名称" prop="name">
          <el-input v-model="query.name"   placeholder="输入位置名称"></el-input>
        </el-form-item>
        <el-form-item label="位置编码" prop="code">
          <el-input v-model="query.code"   placeholder="输入位置编码"></el-input>
        </el-form-item>
        <el-form-item label="推荐类型" prop="type">
          <el-select v-model="query.type" placeholder="请选择">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            width="100"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="位置名称"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="code"
            label="位置编码"
            min-width="160"
            align="center">
          </el-table-column>
          <el-table-column
            prop="type"
            label="推荐类型"
            min-width="160"
            align="center">
            <template slot-scope="scope">
              {{renderPositionType(scope.row.type)}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToPositionEdit(scope.row, scope.$index)">编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToPositionRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <PositionCreate :visible="createDialog" @close="createDialog = false" @submit="fetchRecommendPositionList"></PositionCreate>
    <PositionEdit :visible="editDialog" :content="editRow" @close="editDialog = false" @submit="fetchRecommendPositionList"></PositionEdit>
  </div>
</template>

<script>
import PositionCreate from '@/components/dialog/recommend/PositionCreate'
import PositionEdit from '@/components/dialog/recommend/PositionEdit'
import { recommendPositionList, recommendPositionDestroy } from '@/api/recommend'

export default {
  components: {
    PositionCreate,
    PositionEdit
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      editRow: {},
      query:  {
        name: '',
        code: '',
        type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize') ? Number(localStorage.getItem('pageSize')) : 10,
        isPaging: 1
      },
      types: [
        {label: '全部', value: ''},
        {label: '课程', value: 1},
        {label: '题库', value: 2},
        {label: '阅读资料', value: 3},
        {label: '实体资料', value: 4}
      ],
      pageTotal: 10,
      results: []
    }
  },
  created() {
    this.parseQuery()
    this.fetchRecommendPositionList()
  },
  methods: {
    // 广告位置列表请求
    fetchRecommendPositionList() {
      recommendPositionList(this.query).then(res => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchRecommendPositionList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchRecommendPositionList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchRecommendPositionList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchRecommendPositionList()
    },
    // 广告位置创建
    handlePositionCreate() {
      this.createDialog = true
    },
    // 广告位置编辑
    handleToPositionEdit(row) {
      this.editRow = Object.assign({}, row, {status: row.status == 1 ? true : false})
      this.editDialog = true
    },
    // 广告位置删除
    handleToPositionRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        recommendPositionDestroy({id: row.id}).then(res => {
          this.$message.success(`删除成功`)
          this.fetchRecommendPositionList()
        })
      }).catch(() => {})
    },
    renderPositionType(type) {
      if (!type) {
        return ''
      }
      const list = this.types.filter(item => item.value == type)
      if (list.length) {
        return list[0].label
      }
      return ''
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {

    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
